<template>
  <div class="inspector-fields">
    <Stack style="gap: 1px">
      <Callout
        v-if="isAdditionalPage"
        status="info"
      >
      We pulled this info from the document, but couldn’t pinpoint it on the page.
      </Callout>

      <InspectorField
        v-for="field in pageFields"
        :key="field.path.join()"
        :field="field"
      />
    </Stack>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import InspectorField from './InspectorField.vue';
import { Stack, Callout } from '@stakeui';
import { useInspectorStore } from '@stores/documentInspectorStore.js';

const inspectorStore = useInspectorStore();

const isAdditionalPage = computed(() => inspectorStore.additionalPage && inspectorStore.currentPage === inspectorStore.totalPages);
const pageFields = computed(() => {
  // For non-PDF files, show all fields. TODO: we will have fixed this for docx soon
  if (inspectorStore.fileType !== 'pdf') {
    return inspectorStore.fields;
  }
  // For PDFs, show fields by page
  if (isAdditionalPage.value) {
    return inspectorStore.fields.filter(f => !f.metadata?.bbox || f.pages?.length === 0);
  }
  return inspectorStore.fields.filter(f => f.pages.includes(inspectorStore.currentPage));
});
</script>

<style scoped>
.inspector-fields {
  --radius: 0.5em;
  --spacing: 0.375em;
  --offset: 1.625em;
  padding: 1em;
}
</style>
